import PropTypes from 'prop-types';
import React from 'react';
import styles from './SeatingApp.less';
import moment from 'moment';
import _ from 'lodash';
import MultipleLayoutComponent from '../MultipleLayoutComponent/MultipleLayoutComponent';
import { Popup } from '../Popup';
import Spinner from '@wix/restaurants-components-css-modules/dist/web/Spinner/Spinner';
import I18n from '@wix/wixrest-utils/dist/I18n';
import ReservationHelpers from '@wix/wixrest-utils/dist/openrest-helpers/Reservation';
import TimeUtils from '@wix/wixrest-utils/dist/Time';
import DatePicker from '../../../shared/components/Dropdown/DatePicker/DatePicker';
import Select from '../../../shared/components/Dropdown/Select/Select';
import BigSpinner from '../../../shared/components/Svg/Spinner';
import { getMaxDelay } from '../../../shared/utils/ReservationHelpers';
import { BI } from '@wix/wixrest-bi';

const MIN_STRIP_WIDTH = 750;
const MIN_STRIP_HEIGHT = 195;
const MIN_BOX_WIDTH = 320;
const MIN_BOX_HEIGHT = 396;

export default class extends React.Component {
  static displayName = 'SeatingApp';

  static propTypes = {
    isMobile: PropTypes.bool,
    form: PropTypes.object.isRequired,
    session: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
    restaurant: PropTypes.object.isRequired,
    styles: PropTypes.object.isRequired,
    formActions: PropTypes.object,
    sessionActions: PropTypes.object,
    settingsActions: PropTypes.object,
    fedopsActions: PropTypes.object,
    content: PropTypes.object,
    compId: PropTypes.string,
  };

  static defaultProps = {
    isMobile: false,
  };

  constructor(props) {
    super(props);
    this.dimensions = {};
    this.uniqueId = _.uniqueId('SeatingApp');
    this.inputs = {};

    this.state = {
      isLoading: {},
      isButtonPressed: false,
    };
  }

  componentDidMount() {
    const { sessionActions, isMobile, restaurant } = this.props;
    sessionActions.appLoaded();

    this.dimensions = {
      width: $(this.contentElem).outerWidth(),
      height: $(this.contentElem).outerHeight(),
    };

    if (isMobile || this._isIpad()) {
      const { reservations, timezone } = restaurant || {};
      const value = TimeUtils.serializeDate(
        ReservationHelpers.getFirstAvailableDay(
          reservations,
          moment.tz(timezone),
          timezone
        )
      );
      this._updateField(value, 'date');
    }

    this._delayedResize();
  }

  componentWillReceiveProps(nextProps) {
    const { isButtonPressed } = this.state;
    const { session: newSession, form: newForm } = nextProps;
    const { session, form } = this.props;
    const { step: newStep, loaded } = newSession;
    const { step } = session;
    const { errors: newErrors } = newForm;
    const { errors } = form;

    if (isButtonPressed && (newStep !== step || newErrors !== errors)) {
      this.setState({ isButtonPressed: false });
    }
    const isLoading = _.clone(this.state.isLoading);

    for (let type in loaded) {
      if (loaded[type] === true && this.state.isLoading[type]) {
        delete isLoading[type];
      }
    }

    if (!_.isEqual(isLoading, this.state.isLoading)) {
      this.setState({ isLoading });
    }
  }

  componentDidUpdate(prevProps) {
    const { settingsActions, settings } = this.props;
    const { windowHeight } = settings;
    const newWidth = $(this.contentElem).outerWidth();
    const newHeight = $(this.contentElem).outerHeight();

    if (
      !_.isEmpty(this.dimensions) &&
      settings.initialized &&
      prevProps.settings.initialized
    ) {
      const { height } = this.dimensions;

      if (height > newHeight) {
        settingsActions.resizeComponent({
          height: windowHeight - (height - newHeight),
        });
      }
    }

    this.dimensions = {
      width: newWidth,
      height: newHeight,
    };

    this._errorFocusIfNeeded();

    this._delayedResize();
  }

  render() {
    const {
      isMobile,
      session,
      settings,
      form,
      restaurant,
      settingsActions,
      compId,
    } = this.props;
    const {
      step,
      stepOptions,
      reserveResponse,
      errorResponse,
      preview,
      isEnabled,
      interactions,
      isSendingReservation,
    } = session;
    const { reservation, errors, options } = form;
    const { isCustomDesign, layout } = settings;
    const title = this._getTitle();
    const description = this._getDescription();
    const wrapperClassName = this._getWrapperClassName();
    const headerClassName = this._getHeaderClassName(title, description);
    const formElements = this._getFormElements();
    const showPopup = this._shouldShowPopup();
    const overlay = this._getOverlay();

    return (
      <div
        className={`${styles.wrapper} ${isCustomDesign ? styles.custom : ''} ${
          isMobile ? styles.mobile : ''
        }`}
      >
        <div
          className={wrapperClassName}
          ref={(el) => (this.wrapper = el)}
          data-hook='SeatingApp__container'
        >
          <div
            className={styles.innerContainer}
            ref={(el) => (this.contentElem = el)}
          >
            <div className={headerClassName}>
              {title}
              {description}
            </div>
            <MultipleLayoutComponent
              layout={layout}
              dir={I18n.getDir()}
              settingsActions={settingsActions}
            >
              {formElements}
            </MultipleLayoutComponent>
          </div>
          {step === stepOptions.NOT_ENABLED ? (
            <Popup
              type='notEnabled'
              data={{
                isCustomDesign,
                restaurant,
                reservation,
                form,
                preview,
                isMobile,
                isEnabled,
                interactions,
              }}
              onPublish={this._onPopupPublish}
              onDone={this._closeNotEnabledPopup}
            />
          ) : null}
          {showPopup ? (
            <Popup
              type='details'
              data={{
                reservation,
                errors,
                options,
                reserveResponse,
                errorResponse,
                step,
                stepOptions,
                isCustomDesign,
                restaurant,
                preview,
                compId,
                interactions,
                isSendingReservation,
              }}
              onClose={this._closePopup}
              onSave={this._onConfirmation}
              onUpdate={({ value, type }) => this._updateField(value, type)}
              onPublish={this._onPopupPublish}
              onDone={this._closePopup}
            />
          ) : null}
        </div>
        {overlay}
      </div>
    );
  }

  _shouldShowPopup = () => {
    const { session } = this.props;
    const { step, stepOptions } = session;
    let show = false;

    switch (step) {
      case stepOptions.FORM:
      case stepOptions.SUCCESS:
      case stepOptions.SMS_VALIDATION:
      case stepOptions.ERROR:
        show = true;
        break;
    }

    return show;
  };

  _getFormElements = () => {
    return [
      this._getDatePicker(),
      this._getTimeField(),
      this._getPartyField(),
      this._getButton(),
      this._getAccError(),
    ];
  };

  onOpenDropdown = (type) => {
    const fieldName =
      type === 'party'
        ? 'Party size'
        : type.charAt(0).toUpperCase() + type.slice(1);
    BI.event(BI.EVENTS.RESERVATIONS_CHOOSE_RESERVATION_SETTINGS_CLICK_, {
      fieldName,
      visitorId: window.WixInstance.getVisitorId(),
    });
  };

  _getDatePicker = () => {
    const { form, restaurant, settings, isMobile, compId } = this.props;
    const { reservation, options, errors } = form;
    const { date: dateOptions } = options;
    const { reservations, timezone } = restaurant || {};
    const { isCustomDesign } = settings;
    const maxDate = moment
      .tz(timezone)
      .add(getMaxDelay(reservations), 'minutes');
    let value = reservation.date;

    if (!value && (isMobile || this._isIpad())) {
      value = TimeUtils.serializeDate(
        ReservationHelpers.getFirstAvailableDay(
          reservations,
          moment.tz(timezone),
          timezone
        )
      );
    }

    return (
      <DatePicker
        key='date'
        id={`${compId}-date`}
        ref={(el) => (this.inputs['date'] = el)}
        ariaDescribedBy={`${this.uniqueId}-error`}
        onChange={(value) => this._updateField(value, 'date')}
        onLoad={() => this._onDropdownLoad('date')}
        onClick={(isOpen) => this._onDropdownClick(isOpen, 'date')}
        value={value}
        placeholder={I18n.get('reservations_app_date')}
        locale={I18n.getLocale()}
        dir={I18n.getDir()}
        max={maxDate}
        isMobile={isMobile}
        options={dateOptions}
        error={!!errors.date}
        timezone={timezone}
        reservations={reservations}
        onOpen={() => this.onOpenDropdown('Date')}
        isCustomDesign={isCustomDesign}
      />
    );
  };

  _getTimeField = () => {
    return this._getSelectField('time');
  };

  _getPartyField = () => {
    return this._getSelectField('party');
  };

  _getSelectField = (type) => {
    const { form, settings, compId, isMobile } = this.props;
    const { reservation, options, errors } = form;
    const { isCustomDesign } = settings;

    return (
      <Select
        id={`${compId}-${type}`}
        key={type}
        type={type}
        ref={(el) => (this.inputs[type] = el)}
        ariaDescribedBy={`${this.uniqueId}-error`}
        isCustomDesign={isCustomDesign}
        placeholder={I18n.get(`reservations_app_${type}`)}
        onChange={(value) => this._updateField(value, type)}
        onLoad={() => this._onDropdownLoad(type)}
        onClick={(isOpen) => this._onDropdownClick(isOpen, type)}
        locale={I18n.getLocale()}
        isMobile={isMobile}
        dir={I18n.getDir()}
        value={reservation[type]}
        options={options[type]}
        onOpen={() => this.onOpenDropdown(type)}
        error={!!errors[type]}
      />
    );
  };

  _onDropdownLoad = (type) => {
    const { sessionActions } = this.props;
    sessionActions.dropdownReady({ type });
  };

  _onDropdownClick = (isOpen, type) => {
    const { isLoading } = this.state;
    const { session } = this.props;
    const { loaded } = session;
    let hasChange = !isLoading[type];

    if (!loaded[type]) {
      this.setState({ isLoading: { [type]: true } });
      hasChange = true;
    }
  };

  _getButton = () => {
    const { isButtonPressed } = this.state;
    const buttonText = this._getButtonText();

    return (
      <button
        key='button'
        className={`${styles.button} ${isButtonPressed ? styles.spinner : ''}`}
        tabIndex='0'
        onClick={this._showPopup}
        data-hook='SeatingApp__button'
      >
        {isButtonPressed ? (
          <Spinner radius={24} />
        ) : (
          <span className={styles.btnTxt}>{buttonText}</span>
        )}
      </button>
    );
  };

  _showPopup = () => {
    const { isButtonPressed } = this.state;
    const { sessionActions, form } = this.props;
    const { errors } = form;

    if (!isButtonPressed && _.compact(_.values(errors)).length === 0) {
      this.setState({ isButtonPressed: true }, () => {
        sessionActions.submitReservationForm();
      });
    }
  };

  _closePopup = (data, closePopup = true) => {
    const { formActions, sessionActions } = this.props;

    if (data) {
      const { reservation, options, errors } = data;
      formActions.initForm({ reservation, errors, options });
    }

    if (closePopup) {
      sessionActions.closeDetailsForm();
    }
  };

  _onConfirmation = (data) => {
    const { sessionActions } = this.props;
    this._closePopup(data, false);
    sessionActions.submitFullReservationForm();
  };

  _updateField = (value, type) => {
    const { formActions, isMobile, restaurant } = this.props;
    const { timezone } = restaurant || {};

    if (value) {
      if ((isMobile || !moment.isMoment(value)) && type === 'date') {
        value = TimeUtils.serializeDate(moment.tz(value, timezone));
      }

      formActions.updateField({ value, type });
    } else if (isMobile && type === 'date') {
      value = null;
      formActions.updateField({ value, type });
    }
  };

  _getTitle = () => {
    const { settings, content } = this.props;
    const { showTitle, customTitle } = settings;
    let title = customTitle || content.get('default_title');
    return showTitle ? (
      <h2 className={styles.title} data-hook='SeatingApp__title'>
        {title}
      </h2>
    ) : null;
  };

  _getDescription = () => {
    const { settings } = this.props;
    const { showDescription, customDescription } = settings;
    let description = customDescription;
    return showDescription && customDescription ? (
      <div className={styles.description} data-hook='SeatingApp__description'>
        {description}
      </div>
    ) : null;
  };

  _getButtonText = () => {
    const { settings, content } = this.props;
    const { customButton } = settings;
    return customButton || content.get('default_button');
  };

  _getWrapperClassName = () => {
    const { settings } = this.props;
    const { layout, alignment } = settings;
    let className = styles.container;

    switch (layout) {
      case 0:
        className += ' ' + styles.box;
        break;
      case 1:
        className += ' ' + styles.strip;
        break;
    }

    switch (alignment) {
      case 0:
        className += ' ' + styles.left;
        break;
      case 1:
        className += ' ' + styles.center;
        break;
      case 2:
        className += ' ' + styles.right;
        break;
    }

    return className;
  };

  _getHeaderClassName = (title, description) => {
    return `${styles.header} ${
      title && description
        ? styles.full
        : !title && !description
        ? styles.empty
        : ''
    }`;
  };

  _onPopupPublish = ({ type, data }) => {
    const { sessionActions, fedopsActions } = this.props;

    switch (type) {
      case 'validation':
        let { code } = data;
        sessionActions.smsValidation({ code });
        break;
      case 'back':
        sessionActions.goBack();
        break;
      case 'preview':
        sessionActions.previewReservations();
        break;
      case 'upgrade':
        sessionActions.upgrade();
        break;
      case 'dashboard':
        sessionActions.openDashboard();
        break;
      case 'interaction':
        break;
    }
  };

  _closeNotEnabledPopup = () => {
    const { sessionActions } = this.props;
    sessionActions.gotoStart();
  };

  _getOverlay = () => {
    const { isLoading } = this.state;
    return !_.isEmpty(isLoading) ? (
      <div className={styles.overlay}>
        <BigSpinner />
      </div>
    ) : null;
  };

  _delayedResize = () => {
    setTimeout(this._resizeIfNeeded, 300);
  };

  _resizeIfNeeded = () => {
    const { settings, settingsActions } = this.props;
    const { windowWidth, windowHeight, layout } = settings;
    const contentElem = $(this.contentElem);
    const contentWidth = contentElem.outerWidth();
    const contentHeight = contentElem.outerHeight();
    const newDimensions = {};

    if (contentWidth > windowWidth) {
      newDimensions.width = Math.max(
        contentWidth + 48,
        layout === 0 ? MIN_BOX_WIDTH : MIN_STRIP_WIDTH
      );
    }
    if (contentHeight > windowHeight) {
      newDimensions.height = Math.max(
        contentHeight + 48,
        layout === 0 ? MIN_BOX_HEIGHT : MIN_STRIP_HEIGHT
      );
    }

    if (!_.isEmpty(newDimensions)) {
      settingsActions.resizeComponent(newDimensions);
    }
  };

  _getAccError = () => {
    const { form, content } = this.props;
    const { errors } = form;
    let error = '';

    if (!_.isEmpty(errors)) {
      const emptyErrorKey = _.findKey(errors, (err) => err === 'empty');

      if (emptyErrorKey) {
        error = content.get('error_empty', {
          params: { fieldType: content.get(emptyErrorKey) },
        });
      } else {
        error = _.map(errors, (err) => err)[0];
      }
    }

    return (
      <span
        key='errorLabel'
        role='alert'
        id={`${this.uniqueId}-error`}
        className={styles.errorLabel}
      >
        {error}
      </span>
    );
  };

  _errorFocusIfNeeded = () => {
    const { form } = this.props;
    const { errors } = form;

    const error = _.findKey(errors, (err) => !!err);

    if (error && this.inputs[error]) {
      this.inputs[error].focus();
    }
  };

  _isIpad = () => {
    let isIpad = false;

    if (typeof window !== 'undefined') {
      isIpad = _.get(window, 'navigator.userAgent', '').match(/iPad/i) !== null;
    }

    return isIpad;
  };
}
